export default __webpack_public_path__ + "static/ParkPrice-4b805b325e406ec5268053df22688434.jpg";